// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__273xp","content":"styles_content__2ImEP"};